import defaultClient from '@src/api/clients/default';

const URL = (path = '') => `dashboard/projections/${path}`;

export function fetchProjectionSummary(payload = {}) {
  return defaultClient.request({
    url: URL('estimate/'),
    method: 'POST',
    payload,
    auth: false, // public page use-case
  });
}

export function fetchProjectionZips(payload = {}) {
  return defaultClient.request({
    url: URL('zips/'),
    method: 'POST',
    payload,
    auth: false, // public page use-case
  });
}

export function fetchProjectionZipDemographics(payload = {}) {
  return defaultClient.request({
    url: URL('zip-demographics/'),
    method: 'POST',
    payload,
    auth: false,
  });
}
